var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-list",class:{
    grid: _vm.grid,
    'no-vertical-padding': _vm.noVerticalPadding,
    'with-border': _vm.withBorder,
    'no-side-padding': _vm.noSidePadding,
    'no-padding': _vm.noPadding,
    'horizontal-flow': _vm.horizontal,
  },style:({ 'margin-left': _vm.leftMargin })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }